import { Component, OnInit } from '@angular/core';
import { AnalyticsService, AnalyticsUtility } from 'src/app/services/analytics/analytics.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { WizardService } from 'src/app/services/wizard/wizard.service';
import { environment } from 'src/environments/non-vendor/environment';

@Component({
  selector: 'app-non-vendor-step',
  templateUrl: './start-step.component.html',
  styleUrls: ['./start-step.component.scss']
})
export class StartStepComponent implements OnInit {
  title: string = "";
  subtitle: string = "";
  showFlexLink: boolean = false;
  flexLinkUrl: string = "";
  analyticsStepName: string = AnalyticsUtility.wizardStepName.start;

  constructor(
    private analyticsService: AnalyticsService,
    public wizardService: WizardService,
    private confSvc: ConfigService) { }

  async ngOnInit(): Promise<void> {

    fontLoader(environment.name);

    if (environment.name == "Insight" || environment.name == "Insight Edu") {
      let adobeInsightScript = document.createElement("script");
      adobeInsightScript.type = "text/javascript";
      adobeInsightScript.async = true;
      adobeInsightScript.src = 'src="https://assets.adobedtm.com/launch-EN8416ee41d6164ad3ad99825f55e58bac.min.js"';
      document.head.append(adobeInsightScript);
    }

    await this.confSvc.setup();

    this.title = this.confSvc.getString("startTitle");
    this.subtitle = this.confSvc.getString("startSubtitle");
    this.wizardService.removeAllSelectedWizardOptions();
    this.analyticsService.logCurrentPage(this.analyticsStepName);
    this.showFlexLink = this.confSvc.getBool("showFlexLink");
    this.flexLinkUrl = this.confSvc.getString("flexLinkUrl");
  }

  logLinkClick(){
    this.analyticsService.flexLinkClicked(0);
    window.open(this.flexLinkUrl, "_blank");
  }
}


function fontLoader(vendor: string): void {
  let font = document.createElement("link");
  font.rel="stylesheet";
  font.href = "";
  switch (vendor) {
    case "Insight":
    case "Insight Edu":
      font.href = "https://fonts.googleapis.com/css2?family=Source+Serif+Pro&display=swap";
      break;
    case "Bluum":
      font.href = "https://fonts.googleapis.com/css2?family=Red%20Hat%20Display:wght@300;400;500&display=swap";
      break;
    case "CDW":
      font.href = "https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600&family=Source+Serif+Pro:wght@400&display=swap";
      break;
    case "Connection":
    case "Connection_Gov":
      break;
    case "TD SYNNEX":
    case "TD SYNNEX_PUBLIC":
      break;
    case "D&H":
      font.href = "https://fonts.googleapis.com/css2?family=Red%20Hat%20Display:wght@300;400;500&display=swap";
      break;
    case "Promevo":
      font.href = "https://fonts.googleapis.com/css2?family=Outfit";
      break;
    default:
      font.href = "";
      break;
  };

  document.head.append(font);
  };
